import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/seo/SEOHead';
import SchemaOrg from '../../components/seo/SchemaOrg';
import { allPosts, categories } from '../../mocks/blog-posts';

export default function HomePage() {
  const [visibleNewsCount, setVisibleNewsCount] = useState(12);
  
  // Reorganizar para mostrar os 3 artigos mais recentes primeiro
  const recentThreeArticles = [
    allPosts.find(post => post.slug === 'reforma-tributaria-lucro-presumido-real'),
    allPosts.find(post => post.slug === 'fim-ciap-pis-cofins-reforma-tributaria'),
    allPosts.find(post => post.slug === 'inventario-estoques-ajustes-perdas')
  ].filter(Boolean);
  
  const otherArticles = allPosts.filter(post => 
    post.slug !== 'reforma-tributaria-lucro-presumido-real' &&
    post.slug !== 'fim-ciap-pis-cofins-reforma-tributaria' &&
    post.slug !== 'inventario-estoques-ajustes-perdas'
  );
  
  const orderedPosts = [...recentThreeArticles, ...otherArticles];
  
  // Featured story (first post)
  const featuredStory = orderedPosts[0];
  
  // Top stories (next 3 posts)
  const topStories = orderedPosts.slice(1, 4);
  
  // Latest news
  const latestNews = orderedPosts.slice(4, visibleNewsCount);
  const hasMoreNews = orderedPosts.length > visibleNewsCount;

  const loadMoreNews = () => {
    setVisibleNewsCount(prev => prev + 8);
  };

  return (
    <>
      <SEOHead 
        title="Ativo News - Notícias sobre Contabilidade, Gestão de Ativos e Reforma Tributária"
        description="Portal de notícias especializado em contabilidade, gestão de ativos fixos, estoques, folha de pagamento e reforma tributária. Informações atualizadas para contadores e gestores."
        keywords="contabilidade, ativo fixo, gestão patrimonial, reforma tributária, estoques, folha de pagamento"
        canonical="https://ativonews.com.br"
      />
      <SchemaOrg type="WebSite" data={{
        name: "Ativo News",
        description: "Portal de notícias sobre contabilidade e gestão empresarial",
        url: "https://ativonews.com.br"
      }} />
      
      <div className="min-h-screen bg-white">
        <Navbar />
        
        <main className="pt-20">
          {/* Hero Section - Reforma Tributária */}
          <section className="relative h-[600px] overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/3ca46186d256f6820d7d175b7fb75128.jpg"
              alt="Reforma Tributária 2025"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/40"></div>
            
            <div className="absolute inset-0 flex items-center">
              <div className="max-w-7xl mx-auto px-6 w-full">
                <div className="max-w-3xl">
                  <span className="inline-block px-4 py-2 bg-[#CC0000] text-white text-sm font-bold uppercase mb-6">
                    Reforma Tributária
                  </span>
                  <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
                    Reforma Tributária 2025: O Que Muda Para Sua Empresa
                  </h1>
                  <p className="text-xl text-white/95 mb-8 leading-relaxed">
                    Entenda as principais mudanças da reforma tributária brasileira, os impactos no seu negócio e como se preparar para a transição do sistema tributário. Análises completas, guias práticos e atualizações em tempo real.
                  </p>
                  <div className="flex flex-wrap gap-4">
                    <Link 
                      to="/categoria/reforma-tributaria"
                      className="px-8 py-4 bg-[#CC0000] text-white font-semibold text-base hover:bg-[#A00000] transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Ver Todos os Artigos
                    </Link>
                    <Link 
                      to="/contato"
                      className="px-8 py-4 bg-white text-[#CC0000] font-semibold text-base hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Fale com Especialista
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Timeline Section - Implementação da Reforma Tributária */}
          {/* Seção removida */}

          {/* Blog Section */}
          {/* Featured Articles Grid */}
          <section className="max-w-7xl mx-auto px-6 py-16">
            <div className="max-w-[1400px] mx-auto px-6">
              <div className="grid lg:grid-cols-3 gap-6">
                {/* Left Column - Featured Story */}
                <div className="lg:col-span-2">
                  <Link to={`/artigo/${featuredStory.slug}`} className="group block cursor-pointer">
                    <div className="bg-white">
                      <div className="relative h-[500px] overflow-hidden">
                        <img 
                          src={featuredStory.image}
                          alt={featuredStory.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                        <div className="absolute bottom-0 left-0 right-0 p-8">
                          <span className="inline-block px-3 py-1 bg-[#CC0000] text-white text-xs font-bold uppercase mb-3">
                            {featuredStory.category}
                          </span>
                          <h1 className="text-4xl font-bold text-white leading-tight mb-3 group-hover:text-[#CC0000] transition-colors">
                            {featuredStory.title}
                          </h1>
                          <p className="text-white/90 text-base mb-4 line-clamp-2">
                            {featuredStory.excerpt}
                          </p>
                          <div className="flex items-center gap-3 text-sm text-white/80">
                            <span>{featuredStory.author.name}</span>
                            <span>•</span>
                            <span>{new Date(featuredStory.date).toLocaleDateString('pt-BR', { day: 'numeric', month: 'short' })}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>

                  {/* Top Stories Grid */}
                  <div className="grid md:grid-cols-3 gap-4 mt-6">
                    {topStories.map((post) => (
                      <Link key={post.id} to={`/artigo/${post.slug}`} className="group cursor-pointer">
                        <div className="bg-white h-full">
                          <div className="relative h-40 overflow-hidden">
                            <img 
                              src={post.image}
                              alt={post.title}
                              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                            />
                          </div>
                          <div className="p-4">
                            <span className="inline-block px-2 py-1 bg-black text-white text-[10px] font-bold uppercase mb-2">
                              {post.category}
                            </span>
                            <h3 className="font-bold text-sm text-black leading-tight group-hover:text-[#CC0000] transition-colors line-clamp-3">
                              {post.title}
                            </h3>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

                {/* Right Sidebar */}
                <div className="space-y-6">
                  {/* Trending */}
                  <div className="bg-white p-6">
                    <h3 className="text-lg font-bold text-black mb-4 pb-3 border-b-2 border-[#CC0000]">
                      EM ALTA
                    </h3>
                    <div className="space-y-4">
                      {orderedPosts.slice(0, 5).map((post, index) => (
                        <Link key={post.id} to={`/artigo/${post.slug}`} className="group cursor-pointer">
                          <div className="flex gap-3 pb-4 border-b border-gray-200 last:border-0">
                            <span className="text-3xl font-black text-[#E5E5E5] group-hover:text-[#CC0000] transition-colors flex-shrink-0">
                              {String(index + 1).padStart(2, '0')}
                            </span>
                            <div className="flex-1">
                              <h4 className="text-sm font-bold text-black leading-tight group-hover:text-[#CC0000] transition-colors line-clamp-3">
                                {post.title}
                              </h4>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>

                  {/* Newsletter */}
                  <div className="bg-[#CC0000] p-6 text-white">
                    <h3 className="text-lg font-bold mb-2">NEWSLETTER</h3>
                    <p className="text-sm text-white/90 mb-4">
                      Receba as principais notícias no seu e-mail
                    </p>
                    <input 
                      type="email" 
                      placeholder="Seu e-mail"
                      className="w-full px-4 py-2 text-black mb-3 text-sm"
                    />
                    <button className="w-full px-4 py-2 bg-black text-white font-bold text-sm hover:bg-black/80 transition-colors cursor-pointer">
                      INSCREVER-SE
                    </button>
                  </div>

                  {/* Categories */}
                  <div className="bg-white p-6">
                    <h3 className="text-lg font-bold text-black mb-4 pb-3 border-b-2 border-[#CC0000]">
                      CATEGORIAS
                    </h3>
                    <div className="space-y-2">
                      {categories.map((category) => (
                        <Link 
                          key={category.id}
                          to={`/categoria/${category.slug}`}
                          className="flex items-center justify-between py-2 hover:bg-gray-50 transition-colors cursor-pointer group"
                        >
                          <span className="text-sm text-black group-hover:text-[#CC0000] font-medium">
                            {category.name}
                          </span>
                          <span className="text-xs text-gray-400">
                            {category.count}
                          </span>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Latest News Section */}
              <div className="mt-12">
                <h2 className="text-2xl font-bold text-black mb-6 pb-3 border-b-2 border-[#CC0000]">
                  ÚLTIMAS NOTÍCIAS
                </h2>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                  {latestNews.map((post) => (
                    <Link key={post.id} to={`/artigo/${post.slug}`} className="group cursor-pointer">
                      <div className="bg-white h-full">
                        <div className="relative h-48 overflow-hidden">
                          <img 
                            src={post.image}
                            alt={post.title}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                          />
                          <span className="absolute top-2 left-2 px-2 py-1 bg-[#CC0000] text-white text-[10px] font-bold uppercase">
                            {post.category}
                          </span>
                        </div>
                        <div className="p-4">
                          <h3 className="font-bold text-sm text-black leading-tight mb-2 group-hover:text-[#CC0000] transition-colors line-clamp-3">
                            {post.title}
                          </h3>
                          <p className="text-xs text-gray-600 line-clamp-2 mb-2">
                            {post.excerpt}
                          </p>
                          <div className="flex items-center gap-2 text-xs text-gray-500">
                            <span>{new Date(post.date).toLocaleDateString('pt-BR', { day: 'numeric', month: 'short' })}</span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>

                {hasMoreNews && (
                  <div className="flex justify-center mt-8">
                    <button 
                      onClick={loadMoreNews}
                      className="px-8 py-3 bg-black text-white font-bold text-sm uppercase hover:bg-[#CC0000] transition-colors cursor-pointer whitespace-nowrap"
                    >
                      CARREGAR MAIS
                    </button>
                  </div>
                )}
              </div>
            </div>
          </section>
        </main>
      </div>
      
      <Footer />
    </>
  );
}
